let todayOrBefore = () => {
  return {
      restrict: 'A',
      require: 'ngModel',
      link: (scope, element, attrs, ngModelController) => {
        ngModelController.$validators.todayOrBefore = function(modelValue, viewValue) {
          if (ngModelController.$isEmpty(modelValue) === true) {
              return true;
          }

          let date = moment(modelValue).startOf('day');

          return date.isSameOrBefore(moment().startOf('day'));
        }
      }
  };
};

todayOrBefore.$inject = [];

export default todayOrBefore;



// WEBPACK FOOTER //
// ./client/app/common/field-validators/today-or-before.js